import { render, staticRenderFns } from "./YesterdayLevel1.vue?vue&type=template&id=5196d552&scoped=true"
import script from "./YesterdayLevel1.vue?vue&type=script&lang=js"
export * from "./YesterdayLevel1.vue?vue&type=script&lang=js"
import style0 from "./YesterdayLevel1.vue?vue&type=style&index=0&id=5196d552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5196d552",
  null
  
)

export default component.exports